'use strict';

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const _MajorityDefaults={
defaultFeature:'fdc.features.dashboard',
defaultFeatureTitle:'Dashboard',
fleetInsightPageTitle:'Fleet Insight',
forecastFeatureTitle:'Forecast',
flightMonitorFeatureTitle:'Monitor',
rasterScheduleGraphDescription:'Work and Sleep Pattern',
alertsSource:'fatigue',
hideProfile:!1,
intervalTypesWithThresholdStatus:['duty','trip','flight'],
timelineFatigueAxisRange:{start:0,end:25},
visualNotificationType:NotificationType.AllThresholdsExceeded};


const ContentByTypeMap=new Map([
[FatigueMeterType.Aviation,_.defaults({
abbreviation:'afm',
brandLogoImageUrl:'/images/AFMLogo.svg',
headerIconUrl:'/images/AFMicon.svg',
fullName:'Aviation',
fullAppTitle:'Aviation Fatigue Meter Dashboard',
defaultFeature:'fdc.features.flightMonitor',
defaultFeatureTitle:_MajorityDefaults.flightMonitorFeatureTitle,
hideProfile:!1,
personTypeLabelSingular:'Crew Member',
personTypeLabelPlural:'Crew Members',
heatmapButtonLabel:'Heatmap',
tripLabelPlural:'Flights',
pdfFooterLogoFilename:'AFMicon.png',
pdfCoverLogoFilename:'AFMReportLogo.png',
forecastFeatureTitle:'Monitor',
intervalTypesWithThresholdStatus:['trip','flight'],
timelineFatigueAxisRange:{start:0,end:18},
visualNotificationType:NotificationType.FatigueThresholdExceeded},
_MajorityDefaults)],
[FatigueMeterType.Workforce,_.defaults({
abbreviation:'wfm',
brandLogoImageUrl:'/images/WFMLogo.svg',
headerIconUrl:'/images/WFMicon.svg',
fullName:'Workforce',
fullAppTitle:'Workforce Fatigue Meter',
personTypeLabelSingular:'Worker',
personTypeLabelPlural:'Workers',
heatmapButtonLabel:'Heatmap',
tripLabelPlural:'Trips',
fleetInsightPageTitle:'Team Insight',
pdfFooterLogoFilename:'WFMicon.png',
pdfCoverLogoFilename:'WFMReportLogo.png',
forecastFeatureTitle:'Monitor'},
_MajorityDefaults)],
[FatigueMeterType.Trucking,_.defaults({
abbreviation:'tfm',
brandLogoImageUrl:'/images/TFMLogo.svg',
headerIconUrl:'/images/TFMicon.svg',
fullName:'Trucking',
fullAppTitle:'Trucking Fatigue Meter',
personTypeLabelSingular:'Driver',
personTypeLabelPlural:'Drivers',
heatmapButtonLabel:'Boards',
tripLabelPlural:'Driving',
pdfFooterLogoFilename:'TFMicon.png',
pdfCoverLogoFilename:'TFMReportLogo.png'},
_MajorityDefaults)]]);


ContentByTypeMap.set(FatigueMeterType.WorkforceAviation,_.defaults({
alertsSource:'assessments',
tripLabelPlural:'Flights',
defaultFeature:'fdc.features.forecast',
defaultFeatureTitle:'Monitor',
rasterScheduleGraphDescription:'Work Pattern'},
ContentByTypeMap.get(FatigueMeterType.Workforce),_MajorityDefaults));

ContentByTypeMap.set(FatigueMeterType.Other,ContentByTypeMap.get(FatigueMeterType.Other.asValidType));

for(const[fmType,value]of ContentByTypeMap.entries()){
_.assign(value,{
faviconUrl:`/${value.abbreviation}-favicon.ico`,
appleTouchIconUrl:`/${value.abbreviation}-apple-touch-icon.png`,
webManifestUrl:`/${value.abbreviation}-site.webmanifest`});

}let

FatigueMeterTypeContentProviderService=class FatigueMeterTypeContentProviderService extends BaseService{
constructor($window,$timeout){
super();

this._$window=$window;
this._$timeout=$timeout;

this.updateProvidedContentToType(null);
}

setupDefaultFeatureForUser(cb){
this._fireWhenDefaultFeatureReady=defaultFeature=>cb(defaultFeature);
}

updateProvidedContentToType(newFatigueMeterType){
this._fatigueMeterType=newFatigueMeterType||FatigueMeterTypeContentProviderService.getDefaultType(_.get(this,'_$window.location.hostname',''));
this.providedContent=ContentByTypeMap.get(this._fatigueMeterType);
if(this._fireWhenDefaultFeatureReady){
this._fireWhenDefaultFeatureReady(this.defaultFeature);
this._fireWhenDefaultFeatureReady=null;
}
}

get fatigueMeterType(){
return this._fatigueMeterType;
}

get alertsSource(){
return _.get(this.providedContent,'alertsSource');
}

get faviconUrl(){
return _.get(this.providedContent,'faviconUrl');
}

get appleTouchIconUrl(){
return _.get(this.providedContent,'appleTouchIconUrl');
}

get webManifestUrl(){
return _.get(this.providedContent,'webManifestUrl');
}

get headerIconUrl(){
return _.get(this.providedContent,'headerIconUrl');
}

get fullName(){
return _.get(this.providedContent,'fullName');
}

get fullAppTitle(){
return _.get(this.providedContent,'fullAppTitle');
}

get brandLogoImageUrl(){
return _.get(this.providedContent,'brandLogoImageUrl');
}

get abbreviation(){
return _.get(this.providedContent,'abbreviation');
}

get defaultFeature(){
return _.get(this.providedContent,'defaultFeature',"fdc.features.dashboard");
}

get defaultFeatureTitle(){
return _.get(this.providedContent,'defaultFeatureTitle');
}

get personTypeLabelSingular(){
return _.get(this.providedContent,'personTypeLabelSingular');
}

get personTypeLabelPlural(){
return _.get(this.providedContent,'personTypeLabelPlural');
}

get heatmapButtonLabel(){
return _.get(this.providedContent,'heatmapButtonLabel');
}

get fleetInsightPageTitle(){
return _.get(this.providedContent,'fleetInsightPageTitle');
}

get forecastFeatureTitle(){
return _.get(this.providedContent,'forecastFeatureTitle');
}

get rasterScheduleGraphDescription(){
return _.get(this.providedContent,'rasterScheduleGraphDescription');
}

get pdfFooterLogoFilename(){
return _.get(this.providedContent,'pdfFooterLogoFilename');
}

get pdfCoverLogoFilename(){
return _.get(this.providedContent,'pdfCoverLogoFilename');
}

get tripLabelPlural(){
return _.get(this.providedContent,'tripLabelPlural');
}

get intervalTypesWithThresholdStatus(){
return _.get(this.providedContent,'intervalTypesWithThresholdStatus');
}

get timelineFatigueAxisRange(){
return _.get(this.providedContent,'timelineFatigueAxisRange');
}

get visualNotificationType(){
return _.get(this.providedContent,'visualNotificationType');
}

static get ContentByTypeMap(){
return ContentByTypeMap;
}

static get DefaultContent(){
return ContentByTypeMap.get(FatigueMeterTypeContentProviderService.getDefaultType());
}

static getDefaultType(hostname=''){
if(_.exists(hostname)&&/aviation|afm/.test(hostname)){
return FatigueMeterType.Aviation;
}

if(_.exists(hostname)&&/workforce|wfm/.test(hostname)){
return FatigueMeterType.Workforce;
}

return FatigueMeterType.Trucking;
}};

module.exports=FatigueMeterTypeContentProviderService;
//# sourceMappingURL=fatigueMeterTypeContentProviderService.js.map
